module.exports = __webpack_public_path__ + "static/media/a2_levels_3-6.a0190ad3.png";